<template>
    <div
        :class="[
            isIconInBeginning ? 'flex-row' : 'flex-row-reverse',
            balloonColor,
            balloonSize,
            'balloon-item flex items-center flex-initial w-auto p-3 mt-6 rounded shadow box-2',
        ]"
        :style="customStyle"
    >
        <slot name="icon"></slot>
        <!-- eslint-disable vue/no-v-html -->
        <div
            :class="[defaultDistances, 'leading-6 text-black']"
            v-html="label"
        ></div>
        <!-- eslint-enable -->
    </div>
</template>

<script>
export default {
    name: 'BalloonItem',
    props: {
        /**
         *  "blue" | "orange"
         */
        color: {
            type: String,
            required: false,
            default: 'blue',
            validator(value) {
                // The value must match one of these strings
                return ['blue', 'orange'].indexOf(value) !== -1;
            },
        },
        /**
         *  "sm" | "md" | "lg"
         */
        size: {
            type: String,
            required: false,
            default: '',
            validator(value) {
                // The value must match one of these strings
                return (
                    [
                        '',
                        'sm',
                        'md',
                        'lg',
                    ].indexOf(value) !== -1
                );
            },
        },
        /**
         *  Text within the balloon (Accepts html)
         */
        label: {
            type: String,
            required: true,
        },
        /**
         *  If the icon should be placed to the right or to the left of the label
         */
        iconPosition: {
            type: String,
            required: false,
            default: 'left',
            validator(value) {
                // The value must match one of these strings
                return ['left', 'right', 'none'].indexOf(value) !== -1;
            },
        },
        customStyle: {
            type: Object,
            required: false,
            default: () => {
                return null;
            },
        },
    },
    computed: {
        isIconInBeginning() {
            return this.iconPosition === 'left';
        },
        hasIcon() {
            return this.iconPosition !== 'none';
        },
        defaultDistances() {
            if (this.hasIcon) {
                return this.isIconInBeginning ? 'pr-15 ml-4' : 'pl-15 mr-4';
            }
            return '';
        },
        balloonColor() {
            switch (this.color) {
                case 'blue':
                    return 'bg-blue-100 text-blue-400';
                case 'orange':
                    return 'bg-orange-50 text-orange-200';
                default:
                    return '';
            }
        },
        balloonSize() {
            return this.size === '' ? '' : `max-w-${this.size}`;
        },
    },
};
</script>
